@if (loadError) {
  <umkt-error-display></umkt-error-display>
} @else if (product) {
  <article class="landing">
    <section class="hero">
      <div class="hero__layout">
        <div class="hero__main">
          <div class="hero__identity">
            <img
              class="hero__logo"
              [src]="(product.imageUrl || product.image) | imageFallback"
              [alt]="product.name"
            />
            <div>
              <h1 class="font-highlight">{{ product.name }}</h1>
              @if (variations.length) {
                <p class="hero__count">{{ variations.length }} ofertas disponíveis</p>
              }
            </div>
          </div>

          <div class="hero__copy">
            @if (variations.length) {
              <span class="tag">Oferta exclusiva</span>
            }
            <div class="hero__description" [innerHTML]="sanitizedDescription"></div>
          </div>
        </div>

        @if (fromPrice || categoryName || variations.length) {
          <div class="hero__aside">
            @if (fromPrice || categoryName) {
              <div class="hero__facts">
                @if (fromPrice) {
                  <div class="hero__fact">
                    <span>A partir de</span>
                    <strong>R$ {{ fromPrice.reais }},{{ fromPrice.cents }}/mês</strong>
                  </div>
                }
                @if (fromPrice && categoryName) {
                  <span class="hero__divider" aria-hidden="true"></span>
                }
                @if (categoryName) {
                  <div class="hero__fact">
                    <span>Categoria</span>
                    <strong>{{ categoryName }}</strong>
                  </div>
                }
              </div>
            }
            @if (variations.length) {
              <button type="button" class="sale-button sale-button--hero" (click)="scrollToOffers()">
                Conferir ofertas
              </button>
            }
          </div>
        }
      </div>
    </section>

    @if (variations.length) {
      <section id="campaign-offers" class="offers">
        <h2 class="font-highlight">Escolha sua oferta</h2>
        <umkt-carousel [items]="variations">
          <ng-template #itemTemplate let-variation>
            <umkt-product-card
              [showImage]="false"
              [title]="variation.name"
              [description]="variationText(variation)"
              [price]="offerPrice(variation)"
              [productUuid]="product.uuid"
              [productType]="product.productType || ''"
              [showAddToCart]="true"
              [showQuantitySelector]="true"
              [showLearnMore]="true"
              [addToCartTextOverride]="'components.productCard.buyNow' | i18n"
              [badge]="isRecommended(variation) ? 'Recomendado' : ''"
              (addToCart)="buy(variation, $event.quantity)"
              (learnMore)="openProductPage()"
            />
          </ng-template>
        </umkt-carousel>
      </section>
    }
  </article>
}
